  export default {
    data() {
        return {
            floatingWidth: 0,
            observer: null,
        };
    },
    mounted() {
        this.$nextTick(() => {
            const rowElement = this.$el.querySelector('.following-row');
            if (rowElement) {
                this.observer = new ResizeObserver(() => {
                    this.updateFloatingWidth();
                });

                this.observer.observe(rowElement);
            } else {
                console.warn("floatingTitleMixin: '.following-row' 요소를 찾을 수 없습니다.");
            }
        });
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {
        updateFloatingWidth() {
            const rowElement = this.$el.querySelector('.following-row');
            if (rowElement) {
                this.floatingWidth = rowElement.clientWidth;
            }
        },
    }
}